import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


  function HourlyGraph() {
    
    const data1 = [
        { name: "Clinic 1", y: 10 },
        { name: "Clinic 2", y: 8 },
        { name: "Clinic 3", y: 4 },
        { name: "Clinic 4", y: 6 },
        { name: "Clinic 5", y: 5 },
        { name: "Clinic 6", y: 15 },
        { name: "Clinic 7", y: 7 },
        { name: "Clinic 8", y: 4 },
        { name: "Clinic 9", y: 6 },
        { name: "Clinic 10", y: 3 },
        { name: "Clinic 6", y: 12 },
        { name: "Clinic 7", y: 7 },
        { name: "Clinic 8", y: 2 },
        { name: "Clinic 9", y: 7 },
        { name: "Clinic 10", y: 4 },
      ];
      
      const data2 = [
        { name: "Clinic 1", y: 18 },
        { name: "Clinic 2", y: 6 },
        { name: "Clinic 3", y: 7 },
        { name: "Clinic 4", y: 3 },
        { name: "Clinic 5", y: 4 },
        { name: "Clinic 6", y: 11 },
        { name: "Clinic 7", y: 9 },
        { name: "Clinic 8", y: 5 },
        { name: "Clinic 9", y: 9 },
        { name: "Clinic 10", y: 5 },
        { name: "Clinic 6", y: 4 },
        { name: "Clinic 7", y: 4 },
        { name: "Clinic 8", y: 4 },
        { name: "Clinic 9", y: 4 },
        { name: "Clinic 10", y: 5 },
      ];

      const options = {
        chart: {
          type: "column",
        },
        title: {
          text: "Data",
        },
        xAxis: {
          categories: ["Data"],
        },
        yAxis: {
          title: {
            text: "Number Of Booking",
          },
        },
        series: [
          {
            name: "Booked Time",
            data: data1.map((item) => item.y),
          },
          {
            name: "Call Time",
            data: data2.map((item) => item.y),
          },
        ],
      };
    

    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    );
  }
  

  export default HourlyGraph;